let FormEvent = {
    delete:"deleteForm",
    cancel:"cancelForm",
    initForm:"InitForm",
    submit:"Submit",
    reCall:"ReCall",
    draft:"Draft",
    handOver:"HandOver",
    backOff:"BackOff",
    backOffToLast:"BackOffToLast",
    end:"End",
    operatorForm:"OperatorForm"
}
/**
 * form 内联表单数据初始化模式
 * @param ChangeData 数据父传递传递模式
 */
enum FromDataChangeEvent {
    /**
     *  数据父传递传递模式
     */
    ChangeData
}

const FieldReferenceType = [
    "AttchFileField",
    "ComputedObjectField",
    "ContentPickerField",
    "DateField",
    "DepartField",
    "ImageField",
    "MultChoiceProField",
    "PositionField",
    "SubFormField",
    "UserField"
]

export { FormEvent, FromDataChangeEvent, FieldReferenceType }